import {
  Grid,
  Typography,
  Fade,
  Modal,
  Box,
  Backdrop,
  Button,
} from "@material-ui/core";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper", //   border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const styles = {
  success: {
    color: "#0c5100",
    backgroundColor: "#9cffc3",
    width: "100%",
    margin: "5px auto",
  },
  failed: {
    color: "#f10000",
    backgroundColor: "#fda9a9",
    width: "100%",
    margin: "5px auto",
  },
};

const BillResponseModal = ({ open, successed, failed }) => {
  const handleClose = () => {
    open.handleChange(false);
  };
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open.value}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open.value}>
        <Box sx={style} style={{ borderRadius: "8px" }}>
          <Typography id="transition-modal-title" variant="h6" component="h2">
            وضعیت صدور قبض
          </Typography>
          <Grid container xs={12} sm={12} md={12} lg={12}>
            {successed.length !== 0 ? (
              <Typography variant="h6" component="h6">
                صادر شده
              </Typography>
            ) : null}
            {successed.length !== 0
              ? successed.map((item) => (
                  <div key={item.meter_serial} style={styles.success}>
                    <strong>{item.meter_serial}</strong>
                    {""}:{""}
                    {item.farsi_message}
                  </div>
                ))
              : null}
            {failed.length !== 0 ? (
              <Typography variant="h6" component="h6">
                صادر نشده
              </Typography>
            ) : null}
            {failed.length !== 0
              ? failed.map((item) => (
                  <div key={item.meter_serial} style={styles.failed}>
                    <strong>{item.meter_serial}</strong>
                    {""}:{""}
                    {item.farsi_message}
                  </div>
                ))
              : null}
            <Grid
              style={{ marginTop: "48px" }}
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
            >
              <Button
                onClick={handleClose}
                style={{ color: "#fff" }}
                variant="contained"
                color="secondary"
              >
                متوجه شدم
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Fade>
    </Modal>
  );
};
export default BillResponseModal;
